import { defineStyleConfig } from '@chakra-ui/react';

const tooltip = {
  bg: 'white',
  border: 'tooltip',
  borderRadius: 'md',
};

const variants = {
  tooltip,
};

export const Tooltip = defineStyleConfig({ variants });
